import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const layoutContainer = css({
  width: "100%",
  display: "flex",
  flexDirection: "column",
});

export const heroImage = css({
  position: "relative",
  width: "100%",
  height: "40vh",
  marginTop: 64,

  img: {
    objectFit: "cover",
  },

  [theme.breakpoints.down("md")]: {
    height: "25vh",
  },
});

export const contentContainer = css({
  width: "100%",
  maxWidth: "1440px",
  margin: "0 auto",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const pageTitle = css({
  fontWeight: 700,
  color: theme.palette.primary.main,
  [theme.breakpoints.down("md")]: {
    fontSize: "24px",
  },
});
